import { Component } from '@angular/core';

@Component({
  selector: 'app-info-area',
  templateUrl: './info-area.component.html',
  standalone: false,
  host: {
    'class': 'lg:col-span-4 bg-white dark:bg-black dark:border-[#404040] dark:text-white p-4 py-6 sm:p-6 text-sm border border-gray-200 rounded-l h-full'
  }

})
export class InfoAreaComponent {
}
